import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2152">
      <About data-id="element-2153" />
    </main>;
}